import 'slick-carousel';
import 'jquery-ui';

import searchPopup from './search-popup';
import animatedClassFunc from './animated-class';
import navigationAccordion from './navigation-accordion';
import revealProduts from './shop-room';
import articleCaption from './article-caption';
import mobileNav from './mobile-navigation';
import mobileSearch from './mobile-search';
import mobileHeader from './mobile-header';
import moveShippinCalc from './move-shipping-calc';
import quantity from './quantity';
import collectionSort from './collection-sort';
import printBtn from './print-btn';
import radioFeatures from './radio-features';

import cartReveal from './cart-reveal';
import cartPageUpdate from './cart-page-update';
import { fixedTableHeadings } from './cart-heading';
import cartAjaxUpdate from './cart-ajax-update';
import cartRemoveItem from './cart-remove-item';

import registerForm from './account-login-register';
import toggleForms from './account-forgotten-password';
import addressToggle from './account-address-toggle';
import accountDatepicker from './account-datepicker.js';
import addressCounty from './address-county';

import addAltProductImage from './product-alt-image';
import productVariants from './product-variants';
import radioClick from './radio-click';
import productImages from './product-images';
// import radioHover from './radio-hover';
import radioPopup from './radio-popup';
import cylindo360 from './product-cylindo';
import productAccordion from './product-accordion';
import selectChange from './select-change';
import productFormAjax from './product-form-ajax';
import comColAddAdditionalFields from './com-col-add';
import comColRemove from './com-col-remove';
import printUrl from './product-print';

import flashcanvas from './flashcanvas';
import jsignature from './jsignature';

$(window).on('scroll', function() {
  fixedTableHeadings();  
})

$(document).ready(function() {
	if ($('#wholesale-form-signature').length > 0) {
		var $sigdiv = $("#wholesale-form-signature");
		$sigdiv.jSignature();

		$('.wholesale-signature-glyph').click(function(){
			$sigdiv.jSignature("reset");
			$('#field-contact-signature').val("")
		})

		$('#wholesale-form-signature').bind('change', function(e){
			var datapair = $sigdiv.jSignature("getData")
			$('#field-contact-signature').val("<img src='" + datapair + "'>")
		})
	}
})



// WEBPACK FOOTER //
// ../markup/assets/js/main.js